import NewLoveRubyFuse from './NewLoveRubyFuse';
export default NewLoveRubyFuse;
